/* ✨ util genérico: throttle simple (fuera del componente) */
export type ThrottledFunction<TArguments extends ReadonlyArray<unknown>> = ((
  ...arguments_: TArguments
) => void) & {
  cancel: () => void;
};

export function throttle<TArguments extends ReadonlyArray<unknown>>(
  function_: (...arguments_: TArguments) => void,
  delay = 250,
): ThrottledFunction<TArguments> {
  let last = 0;
  let timer: ReturnType<typeof setTimeout> | null = null;

  const throttled = (...arguments_: TArguments): void => {
    const now = Date.now();
    const remaining = delay - (now - last);

    if (remaining <= 0) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      last = now;
      function_(...arguments_);
    } else {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout((): void => {
        last = Date.now();
        timer = null;
        function_(...arguments_);
      }, remaining);
    }
  };

  throttled.cancel = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return throttled;
}
